import React, { useEffect, useState } from 'react';
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { People } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import "./AdminManagementNodeGroup.css";

export default function AdminManagementNodeGroup(props) {

    const navigate = useNavigate();
    const [active, setActive] = useState();
    const state = useLocation();

    useEffect(() => {
        const activeItemId = state && state.state && state.state.activeItemId;
        if(activeItemId) {
            setActive(activeItemId);
        }
    },[state]);

    return (
        <List component="div" disablePadding>
            <ListItemButton id="3001"
                className={(active === 3001) ? "kmc-console-adminmanagement-litem-active" : ""}
                onClick={() => {
                    navigate('/manage/admins', { state: { isAdminManagementNodeExpand: true } });
                    setActive(3001);
                }
                }>
                <ListItemIcon>
                    <People fontSize='medium' />
                </ListItemIcon>
                <ListItemText primary={'Manage Admins'} />
            </ListItemButton>
        </List>
    )
}